<layout>
    <!-- <app-lesson-header-bar *ngIf="lessonCard" [lessonCard]=lessonCard ></app-lesson-header-bar> -->
    <title>Lesson 1</title>

<div id="background" class="background" [@trigger]="currentState" >
    <div id="dots" >
        <div  
            *ngFor="let d of questions | slice:1" 
            class="dot" 
            [ngClass]="{    
                current: d.questionID == currentQuestionID, 
                correct: isCorrect(d.questionID), 
                incorrect: !isCorrect(d.questionID)}" 
            (click)="goto(d.questionID); scrollToQuestion()">{{d.allCorrect}}</div>          
    </div>

    <div id="lessonTopAnchor"></div>





    <div *ngFor="let q of questions | slice:1; " class="questionContainer" >
        <app-question-template  style="min-height: 30vh"
            class="hide questionMargin" 
            [attr.id]=q.questionID 
            [lessonID]="lessonCard.id" 
            [questionID]="q.questionID" 
            (complete)="markComplete($event)" 
            (incomplete)="markIncomplete($event)"
         ></app-question-template>
    </div>  
    
    <div *ngIf="hasPreviousQuestion" class="mobileBackButton" (click)="goBack(); scrollToQuestion()"><div class="r180"><h1 style="margin: 0">&#10150;</h1></div></div>
    <div *ngIf="hasNextQuestion" class="mobileForwardButton" (click)="goForward();  scrollToQuestion()"><h1 style="margin: 0">&#10149;</h1></div>
    <div *ngIf="allQuestionCorrect && !hasNextQuestion && !rtreturn" class="mobileForwardButton" (click)="gotoNextLesson()"><h1 style="margin: 0">&#10149;</h1></div>
    <div *ngIf="!allQuestionCorrect && !hasNextQuestion && currentQuestionID !== firstIncomplete" class="mobileForwardButton" (click)="gotoLastUnansweredQuestion()" >{{config?.lessonTemplateShortHandQuestion}}{{firstIncomplete}}</div>

    <div class="navigationButtonContainer">
        <div class="left">
            <button *ngIf="hasPreviousQuestion" class="previousButton" (click)="goBack(); scrollToQuestion()">{{config?.lessonTemplateGoBack}}</button     >
        </div>
        <div class=right>
            <button *ngIf="hasNextQuestion" class="nextButton" [@shake]="readyToContinue" (click)="goForward(); scrollToQuestion()">{{config?.lessonTemplateContinue}}</button     >
            <button *ngIf="!allQuestionCorrect && !hasNextQuestion && currentQuestionID === firstIncomplete" class="unansweredNotification regularText button" (click)="gotoLastUnansweredQuestion()" >{{config?.lessonTemplateAnswerAbove}}</button       >
            <button *ngIf="!allQuestionCorrect && !hasNextQuestion  && currentQuestionID !== firstIncomplete" class="unansweredNotification regularText button" (click)="gotoLastUnansweredQuestion()" >{{config?.lessonTemplateQuestion}} {{firstIncomplete}}</button     >
            <button *ngIf="allQuestionCorrect && !hasNextQuestion && lessonID != '25' && !rtreturn" class="nextButton regularText button" (click)="gotoNextLesson()" >{{config?.lessonTemplateNext}} </button       >
            <button *ngIf="allQuestionCorrect && !hasNextQuestion && lessonID == '25' || allQuestionCorrect && !!rtreturn && !hasNextQuestion " class="nextButton regularText button" (click)="finishCourse()" >{{config?.lessonTemplateFinished}} </button     >
        </div>
    </div>
</div>

</layout>